import styled from 'styled-components';
import { color } from '../../assets/styles/colors';

export const Bandeira = styled.img`
	width: 50px;
	height: 50px;
	border: 1px solid ${color.grayMedium};
	padding: 3px;
`;
